import ReportIcon from "@material-ui/icons/Report";

export const FlaggedActivityReportIcon = ReportIcon;
export { FlaggedActivityCreate } from "./create";
export { FlaggedActivityEdit } from "./edit";
export { FlaggedActivityList } from "./list";
